var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Disclaimer.tsx
import { Typography } from "@availity/mui-typography";
import { Link } from "@availity/mui-link";
import { styled } from "@mui/material/styles";
import { jsx, jsxs } from "react/jsx-runtime";
var AvDisclaimer = styled("div", {
  name: "AvDisclaimer",
  slot: "root",
  overridesResolver: (props, styles) => [styles.root, props.accent && styles.accent, props.dense && styles.dense]
})({});
var AvDisclaimerHeader = styled(Typography, {
  name: "AvDisclaimer",
  slot: "header"
})(({ ownerState }) => ({
  marginBottom: ownerState.dense ? "4px" : "8px"
}));
var AvDisclaimerLink = styled(Link, {
  name: "AvDisclaimer",
  slot: "link"
})(({ ownerState }) => ({
  marginTop: ownerState.dense ? "8px" : "16px",
  display: "block"
}));
var Disclaimer = (_a) => {
  var _b = _a, {
    accent = true,
    dense = false,
    description,
    headerText,
    link
  } = _b, rest = __objRest(_b, [
    "accent",
    "dense",
    "description",
    "headerText",
    "link"
  ]);
  let textVariant = "body1";
  let headerVariant = "h5";
  if (dense) {
    textVariant = "body2";
    headerVariant = "h6";
  }
  const ownerState = { dense };
  return /* @__PURE__ */ jsxs(AvDisclaimer, __spreadProps(__spreadValues({ accent, dense }, rest), { children: [
    headerText && /* @__PURE__ */ jsx(AvDisclaimerHeader, { variant: headerVariant, ownerState, color: "text.secondary", children: headerText }),
    /* @__PURE__ */ jsx(Typography, { variant: textVariant, color: "text.secondary", children: description }),
    link && /* @__PURE__ */ jsx(AvDisclaimerLink, __spreadProps(__spreadValues({ ownerState }, link), { iconPosition: "end", variant: textVariant }))
  ] }));
};
export {
  Disclaimer
};
